<template>
  <div :class="classes">
    <m4-table v-bind="$attrs" :tbody="rows">
      <template v-if="hasSlotSettings" v-slot:settings>
        <slot name="settings"></slot>
      </template>
      <template v-if="hasSlotTopRight" v-slot:top_right>
        <slot name="top_right"></slot>
      </template>
    </m4-table>
    <div v-if="pagination && pagination.length > 0" class="grid grid--gap16 paginated_table__pagination">
      <div class="grid__col4 paginated_table__pagination__summary">
        {{ newPaginationSummaryText }}
      </div>
      <div class="grid__col8">
        <m4-pagination @click="clickOnPagination" :items="newPagination" ajax-pagination></m4-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4PaginatedTable",
  data() {
    return {
      loading: false,
      currPaginationItem: null,
      rows: this.tbody ? this.tbody : [],
      newPagination: this.pagination,
      newPaginationSummaryText: this.paginationSummaryText
    };
  },
  props: {
    tbody: Array,
    pagination: Array,
    paginationSummaryText: String
  },
  computed: {
    classes() {
      let classes = ["paginated-table"];
      if (this.loading) {
        classes.push("paginated-table--loading");
      }
      return classes;
    },
    hasSlotSettings() {
      return typeof this.$slots.settings === "function";
    },
    hasSlotTopRight() {
      return typeof this.$slots.top_right === "function";
    }
  },
  methods: {
    clickOnPagination(item) {
      this.currPaginationItem = item;
      this.ajax();
    },
    ajax() {
      if (this.currPaginationItem) {
        this.loading = true;
        window.axios
          .get(this.currPaginationItem.url)
          .then((response) => {
            if (response.data !== undefined) {
              this.loading = false;
              this.rows = response.data.tbody;
              this.newPagination = response.data.pagination;
              this.newPaginationSummaryText = response.data.paginationSummaryText;
            }
          })
          .catch((error) => {
            this.loading = false;
            if (error.response && error.response.data && error.response.data.errors) {
              alert(error.response.data.errors[0].details);
            } else if (error.message) {
              alert(error.message);
            } else {
              alert(error);
            }
          });
      }
    }
  }
};
</script>
